import { render } from "./SolicitudCitas.vue?vue&type=template&id=dfc0fc08"
import script from "./SolicitudCitas.vue?vue&type=script&lang=js"
export * from "./SolicitudCitas.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__